import { string, boolean } from "yup";
// @ts-ignore
import phone from "phone";

export const emailValidationAtom = {
  email: string().email().required("Please enter a valid email address."),
};

export const baseUserInfoValidationSchema = {
  tosConsent: boolean().oneOf(
    [true],
    "Please check box above to accept Terms of Service and Privacy Policy."
  ),
  phone: string()
    .required("Please enter a phone number")
    .test(
      "is-valid-phone",
      "Please enter a valid phone number in the field above.",
      function (value) {
        const validated = phone(value);
        return validated && validated.length > 0;
      }
    ),
};
